/* 重命名 */
import {action} from 'mobx';
import { deviceRename } from '@/services/Home';
import DeviceStore from '@/stores/device';
import {message} from 'antd';
import UserStore from '@/stores/user';
import log from '@/utils/log';

class RenameStore {
  
  @action async deviceRename(params: {cid: string,cidName: string}) {
    
    const id = DeviceStore.DeviceOperation.RebootStore.selectedId(params.cid)[0]
    
    const [error] = await deviceRename({serviceId: id, cidName: params.cidName});
    
    if(error) {
      log({ pageId: 'P28',eventId: 'E2805', ext: ''})
      return false;
    }
  
    log({ pageId: 'P28',eventId: 'E2804', ext: ''})
  
    message.success('操作成功')
  
    await  DeviceStore.DeviceBaseStore.getDeviceList({groupId: UserStore.GroupStore.activeGroupId});
  
  
    return true
    
  }
  
}

export default RenameStore;
